module.exports = __webpack_public_path__ + "static/media/remove_card.6a32a168.svg";